//import { Link } from "gatsby";
//import PropTypes from "prop-types";
import React from "react";
//import { css } from "@emotion/core";

const PageHeader = ({ children, ...props }) => <div {...props}>{children}</div>;

export default PageHeader;
